import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type FilterState = {
  isOnlyUpcoming: boolean;
  isMonthlySubscriptionPrefered: boolean;
  setIsOnlyUpcoming: () => void;
  setIsMonthlySubscriptionPrefered: () => void;
};

export const usePreferredFilter = create<FilterState>()(
  persist(
    (set) => ({
      isOnlyUpcoming: false,
      isMonthlySubscriptionPrefered: false,
      setIsOnlyUpcoming: () =>
        set((state) => ({ isOnlyUpcoming: !state.isOnlyUpcoming })),
      setIsMonthlySubscriptionPrefered: () =>
        set((state) => ({
          isMonthlySubscriptionPrefered: !state.isMonthlySubscriptionPrefered,
        })),
    }),
    {
      name: 'preferred-filter-state', //  localStorage
    }
  )
);

export default usePreferredFilter;
